import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

export function Actions(props: Props) {
  const classes = useStyles({});

  return (
    <div className={classes.root} style={props.style}>
      {props.children}
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    ...theme.mixins.childrenMarginRight(8),
    display: "flex",
    alignItems: "center"
  }
}));
